<div class="loading-container">
  <div class="spacer"></div>

  <div class="logo-wrapper">
    @if (logoUrl(); as logo) {
      <img [src]="logo" alt="Logo" class="heartbeat-logo" />
    }
  </div>

  <div class="footer-progress">
    <div class="text-container">
      <span class="status-text">{{ loadingText() }}</span>
    </div>

    <div class="progress-bar-wrapper">
      <p-progressBar
        [value]="progress()"
        [showValue]="false"
        [style]="{ height: '6px', 'border-radius': '10px' }"
      ></p-progressBar>
    </div>
  </div>
</div>
